import request from '../../src/state/modules/axios'

export function getLidershipExperience(){
    return request({
        url: '/api/lidership-experience',
        method: 'get',
    })
}

export function getLidershipExperienceById(data){
    return request({
        url: `/api/lidership-experience/${data.id}`,
        method: 'get',
    })
}

export function addLidershipExperience(data){
    return request({
        url: '/api/lidership-experience',
        method: 'post',
        data,
    })
}

export function editLidershipExperience(data){
    return request({
        url: `/api/lidership-experience/${data.id}`,
        method: 'put',
        data,
    })
}

export function deleteLidershipExperience(data){
    return request({
        url: `/api/lidership-experience/${data.id}`,
        method: 'delete'
    })
}